import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { LevelDropDownDto } from './level-drop-down-dto';




export class LevelDropDownResponseModel extends GlobalResponseObject {
    data?: LevelDropDownDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: LevelDropDownDto[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}

